import axios from "@util/axios";
import projectConfig from "@projectConfig";

const { hostCloud, scope, socialMediaApi } = projectConfig.api;

export const legacyLogin = async (userData) => {
   const url = `${hostCloud}/legacy/login/v3?scope=${scope}`;
   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "text/plain",
      },
      data: userData,
   });
};
export const getJWT = async () => {
   const url = `${hostCloud}/legacy/jwt`;
   return await axios({
      method: "get",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
   });
};
export const getPHPCookie = async () => {
   const url = `${hostCloud}/legacy/php-cookie`;
   return await axios({
      method: "get",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
   });
};
export const getPHPSite = async () => {
   const url = `${hostCloud}/legacy/request`;

   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: "/site/loginAndRedirect?to=SpecialOffers/SpecialOffers/SpecialOffers",
         httpMethod: "GET",
         isAuthenticated: true,
      },
   });
};

export const legacyLoginStrict = async (userData) => {
   const url = `${hostCloud}/legacy/login/v4?scope=${scope}`;
   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "text/plain",
      },
      data: userData,
   });
};

export const getOAuthCookie = async (hash) => {
   const url = `${socialMediaApi}/cookie`;
   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: { hash: hash },
   });
};

export const loginAsUser = async (userId) => {
   const url = `${hostCloud}/legacy/login-as-user?userOldId=${userId}`;

   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         httpMethod: "POST",
      },
   });
};

export const logoutToAdmin = async () => {
   const url = `${hostCloud}/legacy/logout-to-admin`;

   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         httpMethod: "POST",
      },
   });
};
